<template>
  <div>
    <div class="box">
      <div class="columns">
        <div class="column is-4">
          <article class="panel">
            <p class="panel-heading has-text-primary has-text-weight-bold">
              Dados fiscais
            </p>

            <div class="panel-block">
              <div
                class="columns page-pre-invoice-detail__cols"
                :class="{ 'sc-cte-global': history.invoices.length > 1 }">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Número do Pedido:</h6>
                </div>
                <div class="column has-text-right" v-for="so in history.invoices">
                  <p>
                    <a :href="`/ng#/order-number/${so.order_number}`">
                      {{ so.order_number }}
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div class="panel-block">
              <div
                class="columns page-pre-invoice-detail__cols"
                :class="{ 'sc-cte-global': history.invoices.length > 1 }">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Código de rastreio:</h6>
                </div>
                <div class="column has-text-right" v-for="so in history.invoices">
                  <p>
                    <a
                      :href="`http://status-testing.intelipost.com.br/tracking/${so.tracking_code}`"
                      target="_blank">
                      {{ so.tracking_code }}
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div class="panel-block">
              <div
                class="columns page-pre-invoice-detail__cols"
                :class="{ 'sc-cte-global': history.invoices.length > 1 }">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">{{ getInvoiceLabel(history.invoices[0].invoice) }}:</h6>
                </div>
                <div class="column has-text-right" v-for="so in history.invoices">
                  <p>{{ getInvoiceIdentifier(so.invoice) }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-pre-invoice-detail__panel__block">
              <div class="columns page-pre-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Valor dos produtos:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ getSumOfInvoiceCost(history.invoices, 'products_value') | currency }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-pre-invoice-detail__panel__block">
              <div class="columns page-pre-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Valor TMS:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ getSumOfInvoiceCost(history.invoices, 'total_value') | currency }}</p>
                </div>
              </div>
            </div>
          </article>
        </div>

        <div class="column is-4">
          <article class="panel">
            <p class="panel-heading has-text-primary has-text-weight-bold">
              Dados do Documento de Transporte
            </p>

            <div class="panel-block page-pre-invoice-detail__panel__block">
              <div class="columns page-pre-invoice-detail__cols ">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Número do CTE:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ history.cte.number }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-pre-invoice-detail__panel__block">
              <div class="columns page-pre-invoice-detail__cols ">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Série do CTE:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ history.cte.serie }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-pre-invoice-detail__panel__block">
              <div class="columns page-pre-invoice-detail__cols ">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Chave do CTE:</h6>
                </div>
                <div class="column has-text-right sc-pre-invoice-cte__col">
                  <p>{{ history.cte.key }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-pre-invoice-detail__panel__block">
              <div class="columns page-pre-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Emissor:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ history.cte.company_name }}</p>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>

    <div class="box">
      <sc-table
        :data="history.historic"
        default-sort="last_modified"
        :per-page='pagination.limit'
        paginated>
        <template slot-scope="{ row }">

          <sc-table-column
            field="status"
            label="Status"
            :width="300"
            sortable>
            {{ row.status.label }}
          </sc-table-column>

          <sc-table-column
            field="last_modified"
            label="Modificação do status"
            sortable>
            {{ row.last_modified | date('DD/MM/YYYY - HH:mm:ss') }}
          </sc-table-column>

          <sc-table-column
            field="freight_value"
            label="Valor aprovado">
            {{ row.freight_value | currency}}
          </sc-table-column>

          <sc-table-column
            field="payment_type"
            label="Origem do valor">
          {{ row.payment_type }}
          </sc-table-column>

          <sc-table-column
            field="observation"
            label="Observação">
            {{ row.observation }}
          </sc-table-column>

          <sc-table-column
            field="invoice_number"
            label="N° da Fatura">
            {{ row.invoice_number }}
          </sc-table-column>

          <sc-table-column
            field="user"
            label="Usuário">
          {{ row.user }}
          </sc-table-column>
        </template>
        <template slot="empty">
          <sc-table-empty />
        </template>
      </sc-table>

      <div class="sc-form__footer page-pre-invoice-detail__box-footer">
        <div class="column has-text-right">
          <sc-button @click="$emit('back')">
            Voltar
          </sc-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScTable,
  ScTableColumn,
  ScTableEmpty,
} from '@intelipost-js/secure-components';

import { getInvoiceIdentifier, getInvoiceLabel } from '../../helpers/invoiceValuesHelper';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('recon/preInvoiceDetail/preInvoiceDetailHistory');

export default {
  name: 'sc-pre-invoice-detail-history',
  data() {
    return {
      pagination: {
        page: 1,
        limit: 10,
      },
    };
  },
  computed: {
    ...mapState([
      'loading',
      'history',
    ]),
  },
  methods: {
    ...mapActions(['getHistoryStatus']),
    getSumOfInvoiceCost(invoice_list, cost_property) {
      if (invoice_list.length === 1) {
        return invoice_list[0][cost_property];
      }
      return invoice_list
          .map(invoice => invoice[cost_property])
          .reduce((acc, value) => acc + value, 0);
    },
    getInvoiceIdentifier,
    getInvoiceLabel,
  },
  beforeMount() {
    const { id } = this.$route.params || {};
    const { action } = this.$route.query || {};
    this.getHistoryStatus({ id, action });
  },
  components: {
    ScButton,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
  },
};
</script>
<style lang="scss" scoped>
.sc-pre-invoice-cte__col {
  word-break: break-all;
}
.sc-cte-global {
  flex-direction: column;

  .has-text-right {
    padding-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-history/ScPreInvoiceDetailHistory.vue